import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import styles from './Documentation.module.less';

export default function DocumentationPage() {
	const iframeRef = useRef(null);
	const location = useLocation();

	useEffect(() => {
		const urlParams = new URLSearchParams(location.search);
		const subpage = urlParams.get('subpage');
		const anchor = urlParams.get('anchor');

		if (subpage && iframeRef.current) {
			const baseUrl = `https://docs.virtuix.com/${subpage}`;
			const finalUrl = anchor ? `${baseUrl}#${anchor}` : baseUrl;
			if (iframeRef.current.src !== finalUrl) {
				iframeRef.current.src = finalUrl;
				// Set delay for Anchor links
				if (anchor) {
					setTimeout(() => {
						if (iframeRef.current) {
							iframeRef.current.src = finalUrl;
						}
					}, 300);
				}
			}
		}
	}, [location]);

	return (
		<iframe ref={iframeRef} className={styles.documentsContainer} title="iframeDocs" src="https://docs.virtuix.com/"></iframe>
	);
}
